<template>
  <v-container fluid class="fill-height login">
    <v-row align="center" justify="center" class="mx-auto">
      <v-row justify="center" class="mx-auto">
        <v-col
          class="d-flex align-content-space-around flex-wrap"
          style="width: 85vw"
        >
          <template v-for="item in emploees">
            <v-card
              v-if="item.homeWorkshop"
              :key="item.employeeId"
              class="mx-auto my-4"
              max-width="644"
              width="500"
              @click="login(item)"
            >
              <v-list-item>
                <v-list-item-avatar size="80" color="grey">
                  <v-icon dark size="80"> mdi-account-circle </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >Мастер 1 класса<br />
                    Выиграно мотивити {{ item.motivationWins }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </template>
        </v-col>
        <v-col cols="12" class="text-center"
          >Мастерская по адресу {{ workshop.address }}</v-col
        >
        <v-col cols="12" class="text-center"
          >Нечастые посетители данного ШМ:</v-col
        >
        <v-col cols="12">
          <v-toolbar
            max-width="844"
            rounded="xl"
            color="blue-grey lighten-1"
            class="mx-auto"
          >
            <v-autocomplete
              v-model="selectedUser"
              :items="emploees"
              return-object
              item-text="name"
              label="Сотрудник"
              rounded
              solo
              hide-no-data
              hide-details
            ></v-autocomplete>
            <v-btn
              class="ml-2"
              fab
              :disabled="!selectedUser"
              @click="login(selectedUser)"
            >
              <v-icon>mdi-login</v-icon>
            </v-btn>
          </v-toolbar>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-dialog v-model="codeDialog" persistent max-width="600px">
            <v-card v-if="step === 1">
              <v-card-title class="text-center"> </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <p class="h4 text-center" style="width: 100%">
                        Вы хотете зайти как
                        {{ loginUser ? loginUser.fullName : "" }}
                        <br />
                        отправить код на номер:
                        {{ loginUser ? loginUser.phone : "" }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center">
                      <v-btn text small class="mx-auto" @click="step = 4"
                        >забыл телефон</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeCodeDialog">
                  Отмена
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="green lighten-2"
                  text
                  @click="getCode(loginUser.userId)"
                >
                  Отправить
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
            <v-card v-if="step === 2">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <p class="h4 text-center" style="width: 100%">
                        Код авторизации отправлен на телефон
                        <br />
                        <template v-if="!phoneForgotten">
                          c номером: {{ loginUser ? loginUser.phone : "" }}
                        </template>
                        <template v-else>
                          администратора мастерской
                        </template>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="SMScode"
                        label="Код из SMS"
                        @keydown.enter="codeVerify"
                        ref="smsCode"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeCodeDialog">
                  Отмена
                </v-btn>
                <v-btn color="green lighten-2" text @click="codeVerify">
                  Войти
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="step === 4">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <p class="h4 text-center" style="width: 100%">
                        Код будет отправлен на телефон
                        <br />
                        Администратора
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeCodeDialog">
                  отмена
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="green lighten-2"
                  text
                  @click="sendToAdmin(loginUser.userId)"
                >
                  отправить
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-row>
    <v-row class="row justify-center align-self-end login__three-dote">
      <v-btn data-test-id="loginButton" text small @click="oldlogin = !oldlogin">...</v-btn>
    </v-row>
    <old-login :show="oldlogin"></old-login>
  </v-container>
</template>

<script>
export default {
  name: "Loginpage",
  data() {
    return {
      oldlogin: false,
      step: 1,
      selectedUser: null,
      selectedAdmin: null,
      avatar: null,
      foggetPhone: false,
      SMScode: null,
      codeDialog: false,
      loginUser: null,
    };
  },
  components: {
    oldLogin: () => import("../components/oldLogin"),
    // headerRow: () => import('./components/cashbox/partials/HeaderRow.vue'),
  },
  computed: {
    emploees() {
      return this.$store.state.login.employees;
    },
    admins() {
      return this.$store.state.login.employees;
    },
    workshop() {
      return this.$store.state.login.workshop;
    },
  },
  mounted() {
    this.$store.dispatch("login/getAllEmps");
    this.$store.dispatch("login/getWorkshop");
    // todo добавить получение информации о смене
    // console.log('loginpage')
  },
  methods: {
    closeCodeDialog() {
      this.step = 1;
      this.codeDialog = false;
    },
    sendToAdmin(userId) {
      this.phoneForgotten = true;
      this.$store
        .dispatch("login/getSmsCode", [userId, this.phoneForgotten])
        .then(() => {
          // console.log('code resp', resp)
          this.step = 2;

          this.$nextTick(()=>{
            this.$refs?.smsCode?.$el?.querySelector('input')?.focus()
          })
        })
        .catch((e) => {
          console.log("getSmsCode error", e);
        });
    },
    login(user) {
      this.codeDialog = true;
      this.loginUser = user;
    },
    getCode(userId) {
      this.phoneForgotten = false;
      this.$store
        .dispatch("login/getSmsCode", [userId, this.phoneForgotten])
        .then(() => {
          this.step = 2;

          this.$nextTick(()=>{
            this.$refs?.smsCode?.$el?.querySelector('input')?.focus()
          })
        })
        .catch((e) => {
          console.log("getSmsCode error", e);
        });
    },
    codeVerify() {
      this.$store
        .dispatch("login/VerifySmsCode", [this.loginUser.userId, this.SMScode])
        .then((resp) => {
          console.log("code resp", resp); //todo нужен норамльный ответ хотябы "ОК" или тот же ID в status
          this.$router.push("/");
          this.closeCodeDialog();
        })
        .catch((e) => {
          console.log("VerifySmsCode error", e);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  height: calc(100% - 20px);

  &__three-dote {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>
